import { z } from 'zod'

const jsonLogicVarSchema = z
  .object({
    var: z.string(),
  })
  .strict()

export type VarExpression = z.infer<typeof jsonLogicVarSchema>

export const jsonLogicInEnumSchema = z
  .object({
    in: z.tuple([jsonLogicVarSchema, z.array(z.string())]),
  })
  .strict()

export type InEnumExpression = z.infer<typeof jsonLogicInEnumSchema>

export const jsonLogicInSearchSchema = z.object({
  in: z.tuple([z.string(), jsonLogicVarSchema]),
})

export type InSearchExpression = z.infer<typeof jsonLogicInSearchSchema>

export const jsonLogicGreaterThanSchema = z.object({
  '>': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type GreaterThanExpression = z.infer<typeof jsonLogicGreaterThanSchema>

export const jsonLogicLessThanSchema = z.object({
  '<': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type LessThanExpression = z.infer<typeof jsonLogicLessThanSchema>

export const jsonLogicGreaterThanOrEqualSchema = z.object({
  '>=': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type GreaterThanOrEqualExpression = z.infer<typeof jsonLogicGreaterThanOrEqualSchema>

export const jsonLogicLessThanOrEqualSchema = z.object({
  '<=': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type LessThanOrEqualExpression = z.infer<typeof jsonLogicLessThanOrEqualSchema>

export const jsonLogicEqualityNumberSchema = z.object({
  '==': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type EqualityNumberExpression = z.infer<typeof jsonLogicEqualityNumberSchema>

export const jsonLogicStrictEqualityNumberSchema = z.object({
  '===': z.tuple([jsonLogicVarSchema, z.number()]).or(z.tuple([z.number(), jsonLogicVarSchema])),
})

export type StrictEqualityNumberExpression = z.infer<typeof jsonLogicStrictEqualityNumberSchema>

export const jsonLogicEqualityStringSchema = z.object({
  '==': z.tuple([jsonLogicVarSchema, z.string()]).or(z.tuple([z.string(), jsonLogicVarSchema])),
})

export type EqualityStringExpression = z.infer<typeof jsonLogicEqualityStringSchema>

export const jsonLogicStrictEqualityStringSchema = z.object({
  '===': z.tuple([jsonLogicVarSchema, z.string()]).or(z.tuple([z.string(), jsonLogicVarSchema])),
})

export type StrictEqualityStringExpression = z.infer<typeof jsonLogicStrictEqualityStringSchema>

export const jsonLogicBetweenNumberSchema = z.object({
  between: z.tuple([z.number(), jsonLogicVarSchema, z.number()]),
})

export type BetweenNumberExpression = z.infer<typeof jsonLogicBetweenNumberSchema>

export const jsonLogicBetweenDateSchema = z.object({
  between: z.tuple([z.string(), jsonLogicVarSchema, z.string()]),
})

export type BetweenDateExpression = z.infer<typeof jsonLogicBetweenDateSchema>

export const jsonLogicCustomHasAnySchema = z.object({
  hasAny: z.tuple([jsonLogicVarSchema, z.union([z.array(z.string()), z.string()])]),
})

export type CustomHasAnyExpression = z.infer<typeof jsonLogicCustomHasAnySchema>

const jsonLogicFilterSchema = z.union([
  jsonLogicVarSchema,
  jsonLogicInEnumSchema,
  jsonLogicInSearchSchema,
  jsonLogicGreaterThanSchema,
  jsonLogicLessThanSchema,
  jsonLogicGreaterThanOrEqualSchema,
  jsonLogicLessThanOrEqualSchema,
  jsonLogicEqualityNumberSchema,
  jsonLogicStrictEqualityNumberSchema,
  jsonLogicEqualityStringSchema,
  jsonLogicStrictEqualityStringSchema,
  jsonLogicBetweenNumberSchema,
  jsonLogicBetweenDateSchema,
  jsonLogicCustomHasAnySchema,
])

export type Filter = z.infer<typeof jsonLogicFilterSchema>

const jsonLogicFilterChainSchema = z.object({
  and: z.array(jsonLogicFilterSchema),
})

export type FilterChain = z.infer<typeof jsonLogicFilterChainSchema>
